import { ListItemIcon, MenuItem } from "@material-ui/core"
import type { MouseEvent, ReactElement, Ref } from "react"
import { forwardRef } from "react"

export interface IIconMenuItemProps {
  icon: ReactElement
  label: string
  className?: string
  onClick?: (event: MouseEvent<HTMLElement>) => void
}

function IconMenuItemView(props: IIconMenuItemProps, ref: Ref<any>): ReactElement {
  const { icon, label, className, onClick } = props

  return (
    <MenuItem onClick={onClick} innerRef={ref}>
      <ListItemIcon className={className}>{icon}</ListItemIcon>
      {label}
    </MenuItem>
  )
}

export const IconMenuItem = forwardRef(IconMenuItemView)
